import { useEffect, useState } from "react";
import { Client, IMessage } from "@stomp/stompjs";
import { addNewNotification, addWsNotification, NotificationWsUpdate } from "../redux/slice/inbox/createNotificationSlice";
import { createWebSocketClient, getStompClient } from "../service/websocket";
import { useAuthSlice } from "../redux/slice/authSlice";
import { USER_ROLE_ENTITY_NAMES, USER_ROLES } from "../constants/applicationConstants";
import { useDispatch } from "react-redux";

export const useNotifications = () => {
  const [notifications, setNotifications] = useState<NotificationWsUpdate[]>([]);
  const [unreadCount, setUnreadCount] = useState<number>(0);
  const dispatch = useDispatch();
  const { userInfo } = useAuthSlice();

  useEffect(() => {
    if (!userInfo || !userInfo.userId || !userInfo.entityName) {
      console.log("Waiting for userInfo to be ready...");
      return;
    }

    let stompClient: Client | null = null;

    if (userInfo.notificationEnable) {
      let entityName = userInfo.entityName;
      const entityId = userInfo.entityIds ? userInfo.entityIds[0] : 0;
      const loggedinUserId = userInfo.userId;

      const onConnectHandler = () => {
        const stomp = getStompClient();
        if (!stomp || !stomp.connected) return;

        const subscribeTo = (destination: string) => {
          stomp.subscribe(destination, (message: IMessage) => {
            try {
              const body = message.binaryBody
              ? new TextDecoder("utf-8").decode(message.binaryBody)
              : message.body;
              
              const notification: NotificationWsUpdate = JSON.parse(body);
              dispatch(addWsNotification(notification));
              setNotifications((prev) => [notification, ...prev]);
              console.log("Received notification from", destination, notification);
            } catch (error) {
              console.error("Error parsing notification message:", error);
            }
          });
        };

        console.log("Connected to WebSocket");
        //CS-1395 - Start
        if (userInfo.userRole === USER_ROLES.ROLE_PRACTICESTAFF) {
          subscribeTo(`/update/notifications/PRACTICE_STAFF/${loggedinUserId}`);
          subscribeTo(`/update/notifications/USER/${loggedinUserId}`);
          subscribeTo(`/update/notifications/EVERYONE/0`);
          subscribeTo(`/update/notifications/${entityName}/${entityId}`);
          subscribeTo(`/update/notifications/${entityName}/0`);
        } else if(userInfo.userRole === USER_ROLES.ROLE_PRACTICE_TX){
          subscribeTo(`/update/notifications/PRACTICE_TX/${loggedinUserId}`);
          subscribeTo(`/update/notifications/USER/${loggedinUserId}`);
          subscribeTo(`/update/notifications/EVERYONE/0`);
          subscribeTo(`/update/notifications/${entityName}/${entityId}`);
          subscribeTo(`/update/notifications/${entityName}/0`);
        }else {
          subscribeTo(`/update/notifications/${entityName}/${entityId}`);
          subscribeTo(`/update/notifications/USER/${loggedinUserId}`);
          subscribeTo(`/update/notifications/EVERYONE/0`);
          subscribeTo(`/update/notifications/${entityName}/0`);
        }
        //CS-1395 - End
        if (userInfo.entityName === USER_ROLE_ENTITY_NAMES.ADMIN) {
          subscribeTo(`/update/notifications/USER/0`);
        }
      };

      stompClient = createWebSocketClient(onConnectHandler);

      if (stompClient) stompClient.activate();
    }

    return () => {
      if (userInfo.notificationEnable) {
        stompClient?.deactivate();
      }
    };

  }, [userInfo]);

  return { notifications, unreadCount };
};
